import { render, staticRenderFns } from "./BaseErrorMessage.vue?vue&type=template&id=321d0b14&"
import script from "./BaseErrorMessage.vue?vue&type=script&lang=js&"
export * from "./BaseErrorMessage.vue?vue&type=script&lang=js&"
import style0 from "./BaseErrorMessage.vue?vue&type=style&index=0&id=321d0b14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports